export enum FuelType {
    Electric = 'Electric',
    Hybrid = 'Hybrid',
    Petrol = 'Petrol',
    Diesel = 'Diesel'
}

